// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.worktime-datepicker {
  font-family: 'Roboto', -apple-system, BlinkMacSystemFont;
  width: 100%;
  border: none;
  overflow: hidden;
}
.worktime-datepicker .has-daybookings {
  width: 24px;
  height: 24px;
  line-height: 24px;
  border-radius: 50%;
  text-align: center;
  background: #ff9900;
  margin-left: auto;
  margin-right: auto;
  margin-top: 3px;
}
.worktime-datepicker .react-datepicker__navigation--previous {
  left: 80px;
}
.worktime-datepicker .react-datepicker__navigation--next {
  right: 80px;
}
.worktime-datepicker .react-datepicker__navigation-icon {
  top: 3px;
}
.worktime-datepicker .react-datepicker__header {
  background-color: transparent;
  border-bottom: 1px solid var(--palette-gray-dark);
}
.worktime-datepicker .react-datepicker__header .react-datepicker__current-month {
  margin: 0;
  text-transform: capitalize;
  font-weight: bold;
  font-size: 22px;
  line-height: 1.2;
  letter-spacing: -0.00833em;
  color: var(--palette-primary-dark);
  text-align: center;
}
.worktime-datepicker .react-datepicker__header .react-datepicker__day-names {
  margin-right: 0px;
}
.worktime-datepicker .react-datepicker__header .react-datepicker__day-name {
  color: var(--palette-primary-dark);
  font-size: small;
  letter-spacing: 1px;
}
.worktime-datepicker .react-datepicker__month-container {
  width: 100%;
}
.worktime-datepicker .react-datepicker__month-container .react-datepicker__month {
  margin: 0;
  display: flex;
  flex-direction: column;
}
.worktime-datepicker .react-datepicker__week {
  display: flex;
}
.worktime-datepicker .react-datepicker__day {
  color: var(--palette-primary-dark);
  width: 60px;
  border: 1px solid var(--palette-gray-dark);
  position: relative;
  flex: 1;
  margin: 0;
}
.worktime-datepicker .react-datepicker__day > .day-container {
  display: inline-block;
}
.worktime-datepicker .react-datepicker__day--selected {
  border: 2px solid var(--palette-green-main);
  background-color: var(--palette-white-main);
  border-radius: 0;
}
.worktime-datepicker .worktime-datepicker-hours {
  color: var(--palette-white-main);
  background: var(--palette-green-main);
  font-size: 12px;
  margin: 0;
  line-height: normal;
  border-radius: 10%;
  position: absolute;
  left: 17%;
  z-index: 1;
  overflow: hidden;
  text-overflow: ellipsis;
}
.worktime-datepicker .worktime-datepicker-hours.offset {
  left: 67%;
}
.worktime-datepicker .worktime-datepicker-hours.left-0 {
  left: 0;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.worktime-datepicker .worktime-datepicker-hours.right-0 {
  left: unset;
  right: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.worktime-datepicker .worktime-datepicker-hours.planned {
  background: var(--palette-blue-main);
}
@media (min-width: 451px) {
  .worktime-datepicker .react-datepicker__header {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .worktime-datepicker .react-datepicker__header .react-datepicker__day-name {
    width: 60px;
    margin: 0;
  }
  .worktime-datepicker .react-datepicker__month {
    align-items: center;
  }
}
@media (max-width: 450px) {
  .worktime-datepicker .react-datepicker__header .react-datepicker__day-names {
    display: flex;
    width: 100%;
  }
  .worktime-datepicker .react-datepicker__day-name {
    flex: 1;
  }
  .worktime-datepicker .react-datepicker__navigation--previous {
    left: 40px;
  }
  .worktime-datepicker .react-datepicker__navigation--next {
    right: 40px;
  }
}
`, "",{"version":3,"sources":["webpack://./cssSource/less/calendar.less"],"names":[],"mappings":"AAEA;EACE,wDAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AADF;AAHA;EAOI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AADJ;AAdA;EAmBI,UAAA;AAFJ;AAjBA;EAuBI,WAAA;AAHJ;AApBA;EA2BI,QAAA;AAJJ;AAvBA;EA+BI,6BAAA;EACA,iDAAA;AALJ;AA3BA;EAmCM,SAAA;EACA,0BAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,kCAAA;EACA,kBAAA;AALN;AArCA;EA8CM,iBAAA;AANN;AAxCA;EAkDM,kCAAA;EACA,gBAAA;EACA,mBAAA;AAPN;AA7CA;EAyDI,WAAA;AATJ;AAhDA;EA4DM,SAAA;EACA,aAAA;EACA,sBAAA;AATN;AArDA;EAmEI,aAAA;AAXJ;AAxDA;EAuEI,kCAAA;EACA,WAAA;EACA,0CAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;AAZJ;AAcI;EACI,qBAAA;AAZR;AAnEA;EAoFI,2CAAA;EACA,2CAAA;EACA,gBAAA;AAdJ;AAxEA;EA0FI,gCAAA;EACA,qCAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,uBAAA;AAfJ;AAiBI;EACE,SAAA;AAfN;AAkBI;EACE,OAAA;EACA,yBAAA;EACA,4BAAA;AAhBN;AAmBI;EACE,WAAA;EACA,QAAA;EACA,0BAAA;EACA,6BAAA;AAjBN;AAoBI;EACE,oCAAA;AAlBN;AAwBA;EACE;IAEI,aAAA;IACA,sBAAA;IACA,mBAAA;EAvBJ;EAmBA;IAOM,WAAA;IACA,SAAA;EAvBN;EAeA;IAaI,mBAAA;EAzBJ;AACF;AA8BA;EACE;IAGM,aAAA;IACA,WAAA;EA9BN;EA0BA;IASI,OAAA;EAhCJ;EAuBA;IAaI,UAAA;EAjCJ;EAoBA;IAiBI,WAAA;EAlCJ;AACF","sourcesContent":["@import \"variables\";\n\n.worktime-datepicker {\n  font-family:'Roboto', -apple-system, BlinkMacSystemFont;\n  width: 100%;\n  border: none;\n  overflow: hidden;\n\n  .has-daybookings {\n    width: 24px;\n    height: 24px;\n    line-height: 24px;\n    border-radius: 50%;\n    text-align: center;\n    background: #ff9900;\n    margin-left: auto;\n    margin-right: auto;\n    margin-top: 3px;\n  }\n\n  .react-datepicker__navigation--previous {\n    left: 80px;\n  }\n\n  .react-datepicker__navigation--next {\n    right: 80px;\n  }\n\n  .react-datepicker__navigation-icon {\n    top: 3px;\n  }\n\n  .react-datepicker__header {\n    background-color: transparent;\n    border-bottom: 1px solid var(--palette-gray-dark);\n\n    .react-datepicker__current-month {\n      margin: 0;\n      text-transform: capitalize;\n      font-weight: bold;\n      font-size: 22px;\n      line-height: 1.2;\n      letter-spacing: -0.00833em;\n      color: var(--palette-primary-dark);\n      text-align: center;\n    }\n\n    .react-datepicker__day-names {\n      margin-right: 0px;\n    }\n\n    .react-datepicker__day-name {\n      color: var(--palette-primary-dark);\n      font-size: small;\n      letter-spacing: 1px;\n    }\n  }\n\n  .react-datepicker__month-container {\n    width: 100%;\n\n    .react-datepicker__month {\n      margin: 0;\n      display: flex;\n      flex-direction: column;\n    }\n  }\n\n  .react-datepicker__week {\n    display: flex;\n  }\n\n  .react-datepicker__day {\n    color: var(--palette-primary-dark);\n    width: 60px;\n    border: 1px solid var(--palette-gray-dark);\n    position: relative;\n    flex: 1;\n    margin: 0;\n\n    & > .day-container {\n        display: inline-block;\n    }\n  }\n\n  .react-datepicker__day--selected {\n    border: 2px solid @colorGreen;\n    background-color: @colorWhite;\n    border-radius: 0;\n  }\n\n  .worktime-datepicker-hours {\n    color: @colorWhite;\n    background: @colorGreen;\n    font-size: 12px;\n    margin: 0;\n    line-height: normal;\n    border-radius: 10%;\n    position: absolute;\n    left: 17%;\n    z-index: 1;\n    overflow: hidden;\n    text-overflow: ellipsis;\n\n    &.offset {\n      left: 67%;\n    }\n\n    &.left-0 {\n      left: 0;\n      border-top-left-radius: 0;\n      border-bottom-left-radius: 0;\n    }\n\n    &.right-0 {\n      left: unset;\n      right: 0;\n      border-top-right-radius: 0;\n      border-bottom-right-radius: 0;\n    }\n\n    &.planned {\n      background: @colorBlue;\n    }\n  }\n}\n\n// Styles for wider screens (desktop/tablet)\n@media (min-width: 451px) {\n  .worktime-datepicker {\n    .react-datepicker__header {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n\n      .react-datepicker__day-name {\n        width: 60px;\n        margin: 0;\n      }\n    }\n\n    .react-datepicker__month {\n      align-items: center;\n    }\n  }\n}\n\n// Styles for narrow screens (mobile)\n@media (max-width: 450px) {\n  .worktime-datepicker {\n    .react-datepicker__header {\n      .react-datepicker__day-names {\n        display: flex;\n        width: 100%;\n      }\n    }\n\n    .react-datepicker__day-name {\n      flex: 1;\n    }\n    \n    .react-datepicker__navigation--previous {\n      left: 40px;\n    }\n\n    .react-datepicker__navigation--next {\n      right: 40px;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
